import { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import { Button, Hidden } from '@mui/material';
import { routesPaths } from 'constants/paths';
import { useTranslation } from 'react-i18next';
import {
  ArrowBackIosNewRounded,
  ArrowForwardIosRounded,
} from '@mui/icons-material';

import './AppDemo.scss';
import { DESKTOP_IMAGES, MOBILE_IMAGES } from './constants';

export const AppDemo = () => {
  const [index, setIndex] = useState(1);
  const navigate = useNavigate();
  const { t } = useTranslation();

  const handleSkip = () => navigate(routesPaths.projects, { replace: true });

  const handleNext = () => setIndex(index + 1);
  const handlePrevious = () => setIndex(index - 1);

  return (
    <div className="app-demo d-flex">
      <Hidden mdDown>
        <div
          style={{ backgroundImage: `url(${DESKTOP_IMAGES[index]})` }}
          className="image-container"
        />
      </Hidden>
      <Hidden mdUp>
        <div
          style={{ backgroundImage: `url(${MOBILE_IMAGES[index]})` }}
          className="image-container"
        />
      </Hidden>
      <div className="demo-footer d-flex justify-content-between w-100 align-self-end">
        <Button
          variant="contained"
          disabled={index === 1}
          startIcon={<ArrowBackIosNewRounded color="inherit" />}
          onClick={handlePrevious}
        >
          {t('btn_previous')}
        </Button>
        <Button variant="outlined" onClick={handleSkip}>
          {t('btn_skip')}
        </Button>

        {index === 8 ? (
          <Button variant="contained" onClick={handleSkip}>
            {t('btn_done')}
          </Button>
        ) : (
          <Button
            variant="contained"
            endIcon={<ArrowForwardIosRounded color="inherit" />}
            onClick={handleNext}
          >
            {t('btn_next')}
          </Button>
        )}
      </div>
    </div>
  );
};
